module.exports = __webpack_public_path__ + "img/push-pin.339b0f19.svg";